//Makes it safe to do console.log() always.
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());

// Minified version of isMobile
!function(a){var b=/iPhone/i,c=/iPod/i,d=/iPad/i,e=/(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,f=/Android/i,g=/(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,h=/(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,i=/IEMobile/i,j=/(?=.*\bWindows\b)(?=.*\bARM\b)/i,k=/BlackBerry/i,l=/BB10/i,m=/Opera Mini/i,n=/(CriOS|Chrome)(?=.*\bMobile\b)/i,o=/(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,p=new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)","i"),q=function(a,b){return a.test(b)},r=function(a){var r=a||navigator.userAgent,s=r.split("[FBAN");return"undefined"!=typeof s[1]&&(r=s[0]),s=r.split("Twitter"),"undefined"!=typeof s[1]&&(r=s[0]),this.apple={phone:q(b,r),ipod:q(c,r),tablet:!q(b,r)&&q(d,r),device:q(b,r)||q(c,r)||q(d,r)},this.amazon={phone:q(g,r),tablet:!q(g,r)&&q(h,r),device:q(g,r)||q(h,r)},this.android={phone:q(g,r)||q(e,r),tablet:!q(g,r)&&!q(e,r)&&(q(h,r)||q(f,r)),device:q(g,r)||q(h,r)||q(e,r)||q(f,r)},this.windows={phone:q(i,r),tablet:q(j,r),device:q(i,r)||q(j,r)},this.other={blackberry:q(k,r),blackberry10:q(l,r),opera:q(m,r),firefox:q(o,r),chrome:q(n,r),device:q(k,r)||q(l,r)||q(m,r)||q(o,r)||q(n,r)},this.seven_inch=q(p,r),this.any=this.apple.device||this.android.device||this.windows.device||this.other.device||this.seven_inch,this.phone=this.apple.phone||this.android.phone||this.windows.phone,this.tablet=this.apple.tablet||this.android.tablet||this.windows.tablet,"undefined"==typeof window?this:void 0},s=function(){var a=new r;return a.Class=r,a};"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=r:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=s():"function"==typeof define&&define.amd?define("isMobile",[],a.isMobile=s()):a.isMobile=s()}(this);

jQuery(function($) {

setTimeout(function() {
    // Function to update the padding based on window width
    function updatePadding() {
        // Check if the section with the class 'hero-with-links-full-height' exists
        if (!document.body.classList.contains('templateIndex') && !document.body.classList.contains('fabric_wallpaper')) {
            // Apply padding to content-wrapper only if 'hero-with-links-full-height' is not present
            $('.content-wrapper').css('padding-top', $('#header').height());
        }
    }

    // Call updatePadding on page load
    updatePadding();

    // Call updatePadding on window resize
    $(window).resize(function() {
        updatePadding();
    });
}, 200);

  	if(!isMobile.any) {
      $('body').addClass('isNotMobile');
    }

    if( $('form.add-to-cart-form input#quantity').attr('max') == 0 ) {
      $('form.add-to-cart-form input#quantity').attr('value', '');
      $('form.add-to-cart-form input#quantity').on("change", function() {
        $('form.add-to-cart-form input#quantity').val('');
        $('form.add-to-cart-form input#quantity').attr('value', '');
      });
    }

    var increment_value = $('form.add-to-cart-form input#quantity-b2b').attr('increment');
    var qty_increment = 1;

    if( increment_value !== undefined && increment_value !== '' ) {
      qty_increment = parseInt( increment_value );
    }

    $(document).on("click", ".quantity .plus", function() {
        var wrapper = $(this).parent();
        var input = wrapper.find('input[type=number]');
        var currentValue = parseInt(input.val());
        var maxValue = parseInt(input.attr('max'));

        if( maxValue !== 0 ) {
          input.val(currentValue + qty_increment);
          input.change();

          // Disable add to cart button and show message if max quantity reached
          if (currentValue >= maxValue) {
             //$('.quantity .plus').prop('disabled', true);
             $('#add-to-cart-button').prop('disabled', true);
             $('#add-to-cart-button').css({'background-color': '#999999'});

              $('#add-to-cart-button').val('Not Available');
              $('.quantity-message').text("Only " + maxValue + " available");
              $('.quantity-message').css({'display': 'block', 'text-transform': 'uppercase', 'margin-bottom': '10px'});

          }
        }


    });

    $(document).on("click", ".quantity .minus", function() {
        var wrapper = $(this).parent();
        var input = wrapper.find('input[type=number]');
        var currentValue = parseInt(input.val());
        var minValue = parseInt(input.attr('min'));
        var maxValue = parseInt(input.attr('max'));

        if( maxValue !== 0 ) {
          // Decrease the value
          if (currentValue > minValue) {
              input.val(currentValue - qty_increment);
              input.change();
          }

          var currentValue = parseInt(input.val());

            // Enable plus button if min quantity not reached
            if (currentValue <= maxValue) {
                $('.quantity .plus').prop('disabled', false);
                $('#add-to-cart-btn').prop('disabled', false);
                $('#add-to-cart-btn').removeAttr('disabled');
                document.querySelector('form.add-to-cart-form input[name="add"]').removeAttribute('disabled');
                $('#add-to-cart-button').css({'background-color': '#001f5b'});

                $('#add-to-cart-button').val('Add to cart');
                $('.quantity-message').text("");
                $('.quantity-message').css({'display': 'none'});
            }
        }

    });

  /************** Update the amount available for variants when the variant changes ***********************/

$(document).on("variantChange", function(event, variant) {
    if (variant) {
        updateQuantityMax(variant);
    }
});

// Update the quantity input field based on variant data
function updateQuantityMax(variant) {
    let maxQuantity;

    // Check if inventory management is enabled
    if (variant.inventory_management) {
        if (variant.inventory_policy === 'continue') {
            maxQuantity = 999; // Set a very high max value for overselling
        } else {
            maxQuantity = variant.inventory_quantity; // Use the actual inventory quantity
        }
    } else {
        maxQuantity = ''; // No max limit for non-tracked inventory
    }

    // Update the max attribute dynamically
    const quantityInput = $('form.add-to-cart-form input#quantity');
    quantityInput.attr('max', maxQuantity);

    // Update the Add to Cart button and quantity message based on inventory status
    if (variant.inventory_management && variant.inventory_quantity === 0 && variant.inventory_policy !== 'continue') {
        // Out of stock
        quantityInput.val('');
        $('#add-to-cart-button').prop('disabled', true);
        $('#add-to-cart-button').css({'background-color': '#999999'});
        $('.quantity-message').text("Out of stock").css({'display': 'block'});
    } else {
        // In stock or overselling allowed
        quantityInput.val(1);
        $('#add-to-cart-button').prop('disabled', false);
        $('#add-to-cart-button').css({'background-color': ''});
        $('.quantity-message').css({'display': 'none'});
    }
}

  	/********* QUICK VIEW *********/
  	$(document).on('click', '.product-item .quick-view-btn', function(){
      var url = $(this).data('url');
      $('#loading-overlay').show();

      $.ajax({
        url: url,
        cache: false
      }).success(function(data){
        $('#loading-overlay').hide();
        Simplistic.openModal(data, 'quick-view');
      });

      return false;
    });

  	if($('#side-cart').length > 0) {
    	initSideCart();
  	}

  	
  		$('body').delegate('.add-to-cart-form', 'submit', function(){
            if(validateAddCart($(this))) {
              addToCart($(this));
            }
            return false;
        });
  	

  	$(window).scroll(function(){
      if($(this).scrollTop()<=200) {
        $('.scrollup').fadeOut();
      } else {
        $('.scrollup').fadeIn();
      }

      
    });

  	setTimeout(function() { setupDropdownMenus(); }, 200 );
});

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){

	$('.main-menu .has-dropdown').hoverIntent( {over:navRollOver, out:navRollOut, timeout: 200} );

	function navRollOver(e){
		$(this).addClass('active').find('.submenu:first').slideDown();
	}
	function navRollOut(e){
		$(this).removeClass('active').find('.submenu:first').slideUp();
	}

  	$('[data-menu="button"]').click(function(){
    	$('.menu-mobile').slideToggle();
    	return false;
    });
}

function validateAddCart(form) {
  if(form.find('input[name=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }

      	if(allOptionsSelected) {
          	var errorMsg = form.find('.validation-msg').text();
          	if(errorMsg) {
          		alert(errorMsg);
            } else {
            	alert("The selected variant is sold out.");
            }
        } else {
        	var labels = [];
            form.find('.options label').each(function(key, obj){
                labels.push($(obj).text().replace(':', '').trim());
            });
            alert("You must select a "+labels.join('/')+".");
        }
      	return false;
    }
  	return true;
}

function initSideCart() {
	$('.header .cart-wrap').click(function(e){
      e.stopPropagation();
      showSideCart(true);
      return false;
    });

    $(document).click(function(event){
      if(!$(event.target).closest('#side-cart').length && $(event.target).attr('id')!="loading-overlay" && $('#side-cart').hasClass('open')) {
        hideSideCart();
      }
    });
}

/**
 * Ajax add-to-cart
 */
function addToCart(form){
	$('#loading-overlay').show();
  	if(modal) modal.close();
  	//console.log(form.serialize());return false;
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: form.serialize(),
		dataType: 'json',
		error: addToCartFail,
		success: addToCartSuccess,
		cache: false
	});
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
	updateCartDesc();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  	var response = $.parseJSON(jqXHR.responseText);
  	$('#loading-overlay').hide();
  	Simplistic.openModal('<div class="error-itemincart">'+response.description+'</div>', 'message');
}

function updateCartDesc(){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=side-cart',
		cache: false,
      	success: function(data){
          	$('#loading-overlay').hide();

      		var animate = true;
          	if($('#side-cart').width()>0 && $('#side-cart').hasClass('open')) {
              	animate = false;
            }
          	$('#side-cart').remove();
          	$('#page').append(data);
          	if(modal) modal.close();
          	showSideCart(animate);
      	}
	});
}

function showSideCart(animate) {
  $('body, html').css({overflow: 'hidden'});
  $('#page').addClass('mode-overlay');
  if(animate) {
    setTimeout(function(){$('#side-cart').addClass('open')}, 100);
    setTimeout(function(){$('#side-cart .footer').addClass('open')}, 100);
  } else {
    $('#side-cart').removeClass('ease-animation-slow');
  	$('#side-cart').addClass('open');
    setTimeout(function(){$('#side-cart').addClass('ease-animation-slow')}, 200);
    $('#side-cart .footer').removeClass('ease-animation-slow');
  	$('#side-cart .footer').addClass('open');
    setTimeout(function(){$('#side-cart .footer').addClass('ease-animation-slow')}, 200);
  }
}

function hideSideCart() {
  $('#side-cart').removeClass('open');
  $('#side-cart .footer').removeClass('open');
  $('#page').removeClass('mode-overlay');
  $('body, html').css({overflow: ''});
}

window.SimplisticJS = function (){
  this.formatMoney = "$\{\{amount\}\}";

  this.handleize = function (str) {
    //basic implementation
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css]
    });
    modal.setContent(content);
    modal.open();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    images.each(function(){
      var img = new Image();
      img.onload = function() {
        imagesLoaded++;
        if(imagesLoaded==images.length) {
          callback();
        }
      };
      img.src = $(this).attr('src');
    });
  };
};
window.Simplistic = new SimplisticJS();
